import script from "./HolderSuggestInput.vue?vue&type=script&setup=true&lang=js"
export * from "./HolderSuggestInput.vue?vue&type=script&setup=true&lang=js"

import "./HolderSuggestInput.vue?vue&type=style&index=0&id=a864ccee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a864ccee"]])

export default __exports__